import { Axios } from "./request";

const API_URL = "usersapi/v1/educaion/";

export const EDUCATION_INFORMATION_API = {
  GetEducationInformation: () => {
    return Axios.get(`${API_URL}GetEducationInformation`);
  },
  AddEducationInformation: (body) => {
    return Axios.post(`${API_URL}AddEducationInformation`, body);
  },
  EditEducationInformation: (body) => {
    return Axios.put(`${API_URL}EditEducationInformation`, body);
  },
  GetEducationInformationDetails: (profileNumber) => {
    return Axios.get(`${API_URL}GetEducationInformationDetails?profileNumber=${profileNumber}`);
  },
  GetEducationInformationDetailsAfterApprovalInspector: (profileNumber) => {
    return Axios.get(`${API_URL}GetEducationInformationDetailsAfterApprovalInspector?profileNumber=${profileNumber}`);
  },
};
